import { IsEnum, IsOptional } from 'class-validator';

import { PaymentTypeEnum, PaymentVendorEnum } from '@onArte/shared/database/enums';

export class CartUpdateModel {
  @IsOptional()
  @IsEnum(PaymentTypeEnum)
  public paymentType?: PaymentTypeEnum;

  @IsOptional()
  public promotionCode?: string | null;

  @IsOptional()
  public creditCardId?: string | null;

  @IsOptional()
  public commentToOrder?: string;

  @IsOptional()
  public paymentVendor?: PaymentVendorEnum;

  @IsOptional()
  public paymentGatewayId?: string | null;
}
